"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterHelpSection = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../../analytics-subjects");
var components_1 = require("../../../../../components");
var copy_1 = require("../../../../../copy");
var section_ids_1 = require("../../../../../section-ids");
var utils_1 = require("../../../../../utils");
var SmartMeterHelp_1 = require("./SmartMeterHelp");
var TradMeterHelp_1 = require("./TradMeterHelp");
var TradMeterHelpMultiRate_1 = require("./TradMeterHelpMultiRate");
var MeterHelp = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var supply = _a.supply, fuelType = _a.fuelType;
    var isSmart = supply.states.isSmart;
    var registerCount = supply.registers.length;
    if (!isSmart) {
        return registerCount > 1 ? (react_1.default.createElement(TradMeterHelpMultiRate_1.TradMeterHelpMultiRate, { registerCount: registerCount })) : (react_1.default.createElement(TradMeterHelp_1.TradMeterHelp, null));
    }
    return react_1.default.createElement(SmartMeterHelp_1.SmartMeterHelp, { fuelType: fuelType, registerCount: registerCount });
});
var MeterHelpSection = function (_a) {
    var supply = _a.supply, fuelType = _a.fuelType;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var _b = (0, core_1.useComponents)(), P = _b.P, AccordionGroup = _b.AccordionGroup, Accordion = _b.Accordion, Margin = _b.Margin;
    return (react_1.default.createElement("section", { id: section_ids_1.METER_READINGS_HOW_TO_READ_ID },
        react_1.default.createElement(AccordionGroup, null,
            react_1.default.createElement(Accordion, { title: react_1.default.createElement(Copy, { copyKey: "submitPageHowToReadTitle" }), onToggle: function (expanded) {
                    var _a;
                    if (expanded) {
                        dispatch({
                            name: analytics_subjects_1.SUBMIT_METER_READING_HELP,
                            type: 'click',
                            properties: (_a = {
                                    toggleType: 'OPENED'
                                },
                                _a[core_1.INTERNAL_EVENT_FLAG] = true,
                                _a[analytics_subjects_1.KAPI_ONLY] = true,
                                _a),
                        });
                    }
                } },
                react_1.default.createElement(MeterHelp, { supply: supply, fuelType: fuelType }),
                react_1.default.createElement(Margin, { top: 6 },
                    react_1.default.createElement(P, null,
                        react_1.default.createElement(components_1.ButtonLooksLikeLink, { onClick: function () { return (0, utils_1.scrollTo)(section_ids_1.METER_READINGS_SECTION_ID); } },
                            react_1.default.createElement(Copy, { copyKey: "submitPageBackToRead" }))))))));
};
exports.MeterHelpSection = MeterHelpSection;
